/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleGroupTasksResponse
 */
export interface ScheduleGroupTasksResponse {
    /**
     * 
     * @type {string}
     * @memberof ScheduleGroupTasksResponse
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduleGroupTasksResponse
     */
    botsCount: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduleGroupTasksResponse
     */
    tasksCount: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduleGroupTasksResponse
     */
    durationSeconds: number;
}

/**
 * Check if a given object implements the ScheduleGroupTasksResponse interface.
 */
export function instanceOfScheduleGroupTasksResponse(value: object): value is ScheduleGroupTasksResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('botsCount' in value) || value['botsCount'] === undefined) return false;
    if (!('tasksCount' in value) || value['tasksCount'] === undefined) return false;
    if (!('durationSeconds' in value) || value['durationSeconds'] === undefined) return false;
    return true;
}

export function ScheduleGroupTasksResponseFromJSON(json: any): ScheduleGroupTasksResponse {
    return ScheduleGroupTasksResponseFromJSONTyped(json, false);
}

export function ScheduleGroupTasksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleGroupTasksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'botsCount': json['bots_count'],
        'tasksCount': json['tasks_count'],
        'durationSeconds': json['duration_seconds'],
    };
}

export function ScheduleGroupTasksResponseToJSON(json: any): ScheduleGroupTasksResponse {
    return ScheduleGroupTasksResponseToJSONTyped(json, false);
}

export function ScheduleGroupTasksResponseToJSONTyped(value?: ScheduleGroupTasksResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'bots_count': value['botsCount'],
        'tasks_count': value['tasksCount'],
        'duration_seconds': value['durationSeconds'],
    };
}

